import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Logo } from '../../components/marca/Logo';
import { EstadoTodoBien } from '../../components/ui/Estados';
import { servicioAutenticacion } from '../../../services/ServicioAutenticacion';
import { registrarError } from '../../../domain/errores';
import estilos from './Login.module.css';

export function RecuperarClave() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    setEnviando(true);

    try {
      await servicioAutenticacion.solicitarRecuperacion(email);
    } catch (e) {
      // No se distingue entre correo registrado y no registrado: decirlo
      // permitiría averiguar qué cuentas existen en la plataforma.
      registrarError('recuperarClave', e);
    } finally {
      setEnviando(false);
      setEnviado(true);
    }
  };

  return (
    <div className={estilos.contenedor}>
      <div className={estilos.caja}>
        <div className={estilos.encabezado}>
          <Logo variante="centrado" alto={72} className={estilos.logo} />
          <h1 className={estilos.titulo}>Recuperar clave</h1>
          {!enviado && (
            <p className={estilos.subtitulo}>
              Te enviaremos un enlace para crear una contraseña nueva.
            </p>
          )}
        </div>

        {enviado ? (
          <div className={estilos.acciones}>
            <EstadoTodoBien
              titulo="Revisa tu correo"
              descripcion="Si ese correo tiene una cuenta activa, en unos minutos recibirás un enlace para crear una contraseña nueva. Revisa también la carpeta de spam."
            />
            <Link className={estilos.enlace} to="/acceso">
              Volver al inicio de sesión
            </Link>
          </div>
        ) : (
          <form className={estilos.formulario} onSubmit={enviar} noValidate>
            <Input
              etiqueta="Correo"
              type="email"
              placeholder="nombre@empresa.com"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button type="submit" anchoCompleto cargando={enviando}>
              Enviar enlace
            </Button>

            <div className={estilos.acciones}>
              <Link className={estilos.enlace} to="/acceso">
                Volver al inicio de sesión
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
